import { DateRangeFormPickerWrapper } from '@components/CalendarDateRange';
import { FiltersModal } from '@components/FiltersModal/FiltersModal';
import { Checkbox } from '@gurupay/gp-ui-library';
import { useClearFilter } from '@hooks/useClearFilter.ts';
import type { BATCH_OPERATION_TYPE } from '@pages/batch-operations/utils';
import type { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { BatchStatus } from 'types/operations.ts';

export interface IBatchFilters {
	status?: BatchStatus[];
	paymentType?: BATCH_OPERATION_TYPE[];
	dateTo?: string;
	dateFrom?: string;
}

const statusConfig = [
	{
		label: 'listOfOperations.batchStatuses.executed',
		value: BatchStatus.EXECUTED,
	},
	{
		label: 'listOfOperations.batchStatuses.initializing',
		value: BatchStatus.INITIALIZING,
	},
	{
		label: 'listOfOperations.batchStatuses.unsigned',
		value: BatchStatus.UNSIGNED,
	},
	{
		label: 'listOfOperations.batchStatuses.signing',
		value: BatchStatus.SIGNING,
	},
	{
		label: 'listOfOperations.batchStatuses.signed',
		value: BatchStatus.SIGNED,
	},
	{
		label: 'listOfOperations.batchStatuses.failed',
		value: BatchStatus.FAILED,
	},
];

interface BatchFilterProps {
	onFiltersSubmit: (filters: IBatchFilters) => void;
}

export const BatchListFilter: FC<BatchFilterProps> = ({ onFiltersSubmit }) => {
	const { t } = useTranslation();
	const filterForm = useFormContext<IBatchFilters>();
	const { control, handleSubmit } = filterForm;
	const { hasFilters, handleClear } = useClearFilter(filterForm, onFiltersSubmit);

	return (
		<FiltersModal
			hasFilters={hasFilters}
			onClear={handleClear}
			onSubmit={handleSubmit(onFiltersSubmit)}
		>
			<DateRangeFormPickerWrapper control={control} disabledFuture />

			<Controller
				control={control}
				name="status"
				render={({ field }) => {
					const { onChange, value = [] } = field;

					return (
						<div className="flex flex-wrap gap-space-16">
							{statusConfig.map((item) => {
								const handleChange = (itemValue: boolean) => {
									if (itemValue) {
										onChange([...value, item.value]);
									} else {
										onChange(value.filter((v) => v !== item.value));
									}
								};

								return (
									<Checkbox
										key={item.label}
										checked={value.includes(item.value)}
										label={t(item.label)}
										onChange={handleChange}
									/>
								);
							})}
						</div>
					);
				}}
			/>
		</FiltersModal>
	);
};

BatchListFilter.displayName = 'BatchListFilter';
